export default "__VITE_ASSET__DwjyfG2s__"